<template>
  <div id="article-list">
    <div
      v-if="noArticlesFound"
    >{{ $store.state.user.langEng ? 'No articles matched the search.' : 'Inga artiklar matchade sökningen.'}}</div>
    <transition-group
      name="animate-route"
      mode="out-in"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <article-item
        v-for="(article, i) in articles"
        :key="i + article.id"
        :article="article"
        :showSnippet="showSnippet"
        :showKlasses="showKlasses"
        :toggleFavorites="toggleFavorites"
      />
    </transition-group>

    <div v-if="isFetching" class="fetching-spinner">
      <div class="preloader-wrapper small active">
        <div class="spinner-layer spinner-green-only">
          <div class="circle-clipper left">
            <div class="circle"></div>
          </div><div class="gap-patch">
            <div class="circle"></div>
          </div><div class="circle-clipper right">
            <div class="circle"></div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="fetchedAllArticles && !noArticlesFound"
    >{{ $store.state.user.langEng ? 'No more articles matched the search.' : 'Inga fler artiklar matchade sökningen.'}}</div>
  </div>
</template>

<script>
import { Vue, Component, Prop } from "vue-property-decorator";
import { eventBus } from "@/main";

@Component({
  components: {
    ArticleItem: () => import("./ArticleItem"),
  },
})
export default class ArticleList extends Vue {
  @Prop() articles;
  @Prop() showSnippet;
  @Prop() showKlasses;
  toggleFavorites = false;

  get isFetching() {
    return this.$store.state.article.isFetching
  }

  get noArticlesFound() {
    return this.$store.state.article.articles.length == 0;
  }

  get fetchedAllArticles() {
    return this.$store.state.article.didDisplayAllArticles;
  }

  mounted() {
    eventBus.$on("toggleFavorites", (val) => {
      this.toggleFavorites = val;
    });
  }

  beforeDestroy() {
    eventBus.$off("toggleFavorites");
  }
}
</script>

<style scoped lang="scss">
#article-list {
  animation-duration: 125ms;
  padding: 0 !important;

  .fetching-spinner {
    display: flex;
    justify-content: center !important;
  }
}
</style>
